import { render, staticRenderFns } from "./detail-save.vue?vue&type=template&id=5f5d6188&"
import script from "./detail-save.vue?vue&type=script&lang=js&"
export * from "./detail-save.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports